import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PublicPage } from '../../../components/public-page/public-page';

export function PasswordResetComplete() {
  return (
    <PublicPage
      title={
        <FormattedMessage
          id="KS_P_PW_RESET_COMPLETE_TITLE"
          defaultMessage="Změna hesla byla dokončena"
        />
      }
    >
      <FormattedMessage
        id="KS_P_PW_RESET_COMPLETE_SUBTITLE"
        defaultMessage="Pokračujte přihlášením do aplikace."
      />
    </PublicPage>
  );
}
